import { createSelector } from 'reselect';

import { Plus100Status } from '~/src/entities/speed-bonus/context/constants';
import { TInitialState } from '~/src/entities/speed-bonus/context/reducer';
import { selectedRouter, selectRouters } from '~/src/entities/speed-bonus/context/selectors';

export const routerSelectionButtonText = createSelector(
    [
        (state: TInitialState) => state.tariff,
        (state: TInitialState) => selectRouters(state),
        (state: TInitialState) => selectedRouter(state),
    ],
    (tariff, routers, router) => {
        if (tariff?.speedBonusStatus === Plus100Status) {
            return (!routers.length || typeof router !== 'undefined')
                ? 'Оформить заявку'
                : 'Оформить заявку без роутера';
        }

        return typeof router !== 'undefined'
            ? 'Подключить бонус и оформить заявку'
            : 'Подключить бонус без роутера';
    },
);
